// src/redux/authSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AuthService from "../../services/api/authService";
import AppSecureStorage from "../../services/secureStorage";
import { toast } from "react-toastify";
import { message } from "antd";

const auth = new AuthService();
const storage = new AppSecureStorage();
export const googleLogin = createAsyncThunk(
  "auth/googleLogin",
  async ({ data, navigate }, { dispatch }) => {
    dispatch(setLoading(true));
    const body = {
      clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || data.clientId,
      credentials: data.credential,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    dispatch(setCredentials(body));
    try {
      dispatch(setIsSidebarActive(false));
      document.body.style.opacity = 1;
      const response = await auth.login(body);
      storage.set("permissions", JSON.stringify(response.data.permissions));
      if (response) {
        dispatch(setIsSidebarActive(true));
        dispatch(setRole(response.data.role));
        storage.set("token", response.data.accessToken);
        storage.set("tokenExpiry", response.data.expiry);
        storage.set("role", response.data.role);
        storage.set("domain", response.data.email);
        storage.set("id", response.data.id);
        storage.set("name", response.data.name);
        storage.set("orgId", response?.data?.organisationId);
        storage.set("profilePicture", response?.data?.picture);
        const permissions = { Chat: ["Get"] };
        const firstKey = Object.keys(permissions)[0];
        let role = storage.get("role");
        if (role === "superadmin") {
          navigate("/analytics");
          window.location.replace("/analytics");
        } else {
          dispatch(setIsSidebarActive(true));
          navigate(`/${firstKey.toLowerCase()}`, { replace: true });
          window.location.replace(`/${firstKey.toLowerCase()}`);
        }
        if (response) {
          dispatch(setIsSidebarActive(true));
          dispatch(setLoading(false));
        }
        return response.data;
      } else {
        dispatch(setLoading(false));
        throw new Error();
      }
    } catch (error) {
      message.error(error?.data?.message ?? "Login failed. Please try again."); 
      dispatch(setIsSidebarActive(false));
      dispatch(setLoading(false));
    }
  }
);

export const refreshUserData = createAsyncThunk(
  "auth/refreshUserData",
  async ({ selectedRole }, { dispatch }) => {
    try {
      const response = await auth.getPermission();
      storage.set("role", selectedRole);
      storage.set("permissions", JSON.stringify(response));
      dispatch(setRole(selectedRole));
      return response.data;
    } catch (error) {
      toast.error("Failed to refresh user data. Please try again later.");
      throw error;
    }
  }
);
const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    loading: "idle",
    clientId: null,
    credentials: null,
    role: null,
    loader: false,
    isSidebarActive: false,
  },
  reducers: {
    setCredentials: (state, action) => {
      state.clientId = action.payload.clientId;
      state.credentials = action.payload.credentials;
    },
    setRole: (state, action) => {
      state.role = action.payload;
    },
    setLoading: (state, action) => {
      state.loader = action.payload;
    },
    setIsSidebarActive: (state, action) => {
      state.isSidebarActive = action.payload;
    },

    extraReducers: (builder) => {
      builder
        .addCase(googleLogin.pending, (state) => {
          state.loading = "loading";
        })
        .addCase(googleLogin.fulfilled, (state, action) => {
          state.loading = "succeeded";
          state.user = action.payload;
        })
        .addCase(googleLogin.rejected, (state) => {
          state.loading = "failed";
        });
    },
  },
});

export const { setCredentials, setRole, setLoading, setIsSidebarActive } =
  authSlice.actions;

export default authSlice.reducer;
